import { render, staticRenderFns } from "./InstantCheckout.vue?vue&type=template&id=3546fec1&"
import script from "./InstantCheckout.vue?vue&type=script&lang=js&"
export * from "./InstantCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports